var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-contenter"},[(_vm.publicAppMounted)?_c('layout'):_vm._e(),_c('div',{attrs:{"id":"publicComponents"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }